/* eslint-disable no-undef */
export const contratPDF =
    'https://publichthimages.s3.eu-west-3.amazonaws.com/plateformDocuments/Contrat_datadelegates.pdf'
    ||
    'https://publichthimages.s3.eu-west-3.amazonaws.com/plateformDocuments/contratHTH.pdf'
    ;
export const attestationHonneurPDF =
    'https://publichthimages.s3.eu-west-3.amazonaws.com/plateformDocuments/attestationHonneurDataDelegates.pdf'
    ||
    'https://publichthimages.s3.eu-west-3.amazonaws.com/plateformDocuments/attestationHonneurHTH.pdf'
    ;
// * Backend
export const BACKEND_ENV = 'PROD'; // DEV == TEST  || PROD || DD
// export const BACKEND_ENV = process.env.REACT_APP_BACKEND_ENV; // DEV == TEST  || PROD || DD
export const version = 'v1.1.1'; // Front end Version
// const AWS_BACKEND_URL = 'http://localhost:5000/'; //(for local tests)
const AWS_BACKEND_URL = `https://${(BACKEND_ENV === 'PROD') ? '' : (BACKEND_ENV === 'DD') ? 'datadelegates.' : 'test.'}hightechhires.com/`;
// const AWS_BACKEND_URL = 'https://www.hightechhires.com/';

const getBackendURLByENV = () => {
    // console.log(process.env.NODE_ENV,process.env.NODE_ENV=='development',process.env.REACT_APP_API_SERVER_FILES || AWS_BACKEND_URL);
    if (process.env.NODE_ENV == 'production') return AWS_BACKEND_URL;
    // If he found .env he will use it, otherwise he will use the default one which is the remote
    else if (process.env.NODE_ENV == 'development') return process.env.REACT_APP_API_SERVER_FILES || AWS_BACKEND_URL;
    else return AWS_BACKEND_URL;
};

const FILE_STORAGE = 'AWS'; // FILE_SYSTEM
const AwsRegion = 'eu-west-3';
const bucketName = (BACKEND_ENV == 'PROD') ? 'hthstorage' : (BACKEND_ENV === 'DD') ? 'ddhth' : 'publichthimages';
const bucketUrl = `https://${bucketName}.s3.${AwsRegion}.amazonaws.com/`;
export const API_SERVER_FILES = FILE_STORAGE == 'AWS' ? bucketUrl : getBackendURLByENV();
// *CV theque
// * Backend API
export const API_URI = getBackendURLByENV() + 'api/';

export const CLOUD_IMAGES_PROVIDER = 'AWS'; //* or CLOUDINARY

export const getCVThequeENV = () => {
    // * if it is 'local' => direct request to the container, else if 'remote' => pass by backend as a proxy
    // ? bsc: in this case: no need to setup security, since it is already secured by the backend, no need to have and ssl certif, no need to have a domain name (|| reverse proxy config), and also there is a rule: domains serving https, could not call http domains .. so ssl certif was really a must
    if (process.env.NODE_ENV == 'production') return 'remote';
    else if (process.env.NODE_ENV == 'development') return 'local'; //@aida: you can set this to 'local', if you want to do a local dev
    else return 'remote';
};

export const API_URI_CVTheque = 'http://localhost:8000/';
// export const API_URI_CVTheque = process.env.REACT_APP_API_URI_CVTheque
//     || 'http://localhost:8000/'
//     || 'http://15.188.0.4:8000/';
// OLD : https://hth-dev1.herokuapp.com/ -- export const API_SERVER_FILES = "https://hth-v1.herokuapp.com/";

export const ROLES = {
    Client: 1408,
    Expert: 1498,
    Admin: 5150,
    Esn: 2803,
};

// ! mitigate dos attacks, instead of captcha
// ! in odrer to not have a lot of requests {dos}
export const DELAY = 2000;

// cloudinary Configs
export const CLOUDINARY_CONFIG = {
    upload_preset: 'm77ax10m',
    cloud_name: 'dwk27zusp',
    url: 'https://api.cloudinary.com/v1_1/dwk27zusp/image/upload'
};

// https://console.cloud.google.com/apis/credentials/consent?project=hth-frontend&supportedpurview=project
export const GOOGLE_OAUTH_CLIENT_KEY = {
    clientId: '894193771395-fi5mj4lugjrcklmu8ro9vrdrcj4pr1mu.apps.googleusercontent.com'
};
// https://api-ninjas.com/profile
// https://api-ninjas.com/api/city
export const API_KEY_CITY = '2Wur8HxiGfjkQpXQQrSeHg==Rt6xl3WLBfQaX9m2';
export const GA_MEASUREMENT_ID = 'G-X9FCKXVW38';

export const MAX_SIZE_UPLOADED_FILE = 5 * 1024 * 1024; // 5 MB file size limit
export const MAX_SIZE_UPLOADED_IMG = 2 * 1024 * 1024; // 2 MB file size limit

// export const url = process.env.NODE_ENV === "production" ? "https://tamrini.com" : "http://localhost:5000";
// export const API_SERVER_FILES = "https://hth-dev1.herokuapp.com/";

// STEPS : 1 change URLS of config.js => yarn build, place the build files in the backend directory